// extracted by mini-css-extract-plugin
export const mainSection = "disclaimer-module--mainSection--334LI";
export const contentWrap = "disclaimer-module--contentWrap--RPOAy";
export const content = "disclaimer-module--content--16wUu";
export const wrapper = "disclaimer-module--wrapper--tKxt5";
export const footer_contact_info = "disclaimer-module--footer_contact_info--2piO6";
export const componentWrapper = "disclaimer-module--componentWrapper--2AnIA";